import React, { Component } from "react";
import { Row, Col } from "reactstrap";
import Select from "react-select";
import "../../../pages/dashboard/Analytics.css";
import "../../../components/Pagination/Pagination.css";

const ROW_COUNT_OPTIONS = [
  { value: 10, label: "10 rows" },
  { value: 20, label: "20 rows" },
  { value: 30, label: "30 rows" },
  { value: 40, label: "40 rows" },
  { value: 50, label: "50 rows" },
];

class Pagination extends Component {
  generateWindowedPages = () => {
    const { currentPage, totalPageNumber, handlePageNavigation } = this.props;
    const pageWindow = 5;
    const pages = [];

    const startPage = Math.max(currentPage - pageWindow, 1);
    const endPage = Math.min(currentPage + pageWindow, totalPageNumber);

    if (startPage > 1) {
      pages.push(
        <li key="first" className="page-item">
          <span
            className="page-link"
            onClick={() => handlePageNavigation("first")}
          >
            1
          </span>
        </li>
      );
      if (startPage > 2) {
        pages.push(
          <li key="ellipsis-start" className="page-item disabled">
            <span className="page-link">...</span>
          </li>
        );
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <li
          key={i}
          className={`page-item ${
            this.props.currentPage === i ? "active" : ""
          }`}
        >
          <span
          style={{cursor: "pointer"}}
            className="page-link"
            onClick={() => this.props.handlePageNavigation(i)}
          >
            {i}
          </span>
        </li>
      );
    }

    if (endPage < totalPageNumber) {
      if (endPage < totalPageNumber - 1) {
        pages.push(
          <li key="ellipsis-end" className="page-item disabled">
            <span className="page-link">...</span>
          </li>
        );
      }
      pages.push(
        <li key="last" className="page-item">
          <span
            className="page-link"
            onClick={() => handlePageNavigation("last")}
          >
            {totalPageNumber}
          </span>
        </li>
      );
    }

    return pages;
  };

  render() {
    const {
      currentPage,
      totalPageNumber,
      handlePageNavigation,
      handleRecordCountChange,
      recordCount,
      totalRecords,
    } = this.props;

    return (
      <div className="meta-pagination-wrapper">
        <Row className="mt-4 mb-3">
          <Col className="text-left">
            <span className="showpageCount">{`Total records : ${totalRecords}`}</span>
          </Col>
          <Col className="text-center">
            <span className="showpageCount">{`Showing Page ${currentPage} of ${totalPageNumber ||
              1}`}</span>
          </Col>
          <Col className="text-right">
            <Select
              className="meta-rows-select"
              clearable={false}
              searchable={false}
              options={ROW_COUNT_OPTIONS}
              value={recordCount}
              onChange={(selected) =>
                handleRecordCountChange({ target: { value: selected.value } })
              }
            />
          </Col>
        </Row>

        <Row className="pagination">
          <nav aria-label="Page navigation example" className="text-center">
            <ul className="pagination">
              <li
                className={`page-item previousBtnArrow ${
                    currentPage <= 1 ? "disabledLiElement" : ""
                    }`}
                    >
                <span
                  style={{cursor: "pointer"}}
                  className="page-link previousBtnArrow"
                  onClick={() => handlePageNavigation("previous")}
                ></span>
              </li>
              <li
                className={`page-item previousBtn ${
                    currentPage <= 1 ? "disabledLiElement" : ""
                    }`}
                    >
                <span
                  style={{cursor: "pointer"}}
                  className="page-link"
                  onClick={() => handlePageNavigation("previous")}
                >
                  Previous
                </span>
              </li>

              {this.generateWindowedPages()}

              <li
                className={`page-item nextBtn ${
                    currentPage >= totalPageNumber ? "disabledLiElement" : ""
                    }`}
                    >
                <span
                  style={{cursor: "pointer"}}
                  className="page-link"
                  onClick={() => handlePageNavigation("next")}
                >
                  Next
                </span>
              </li>
              <li
                className={`page-item nextBtnArrow ${
                    currentPage >= totalPageNumber ? "disabledLiElement" : ""
                    }`}
                    >
                <span
                  style={{cursor: "pointer"}}
                  className="page-link nextBtnArrow"
                  onClick={() => handlePageNavigation("next")}
                ></span>
              </li>
            </ul>
          </nav>
        </Row>
      </div>
    );
  }
}

export default Pagination;
